import { Routes } from "@angular/router";
export const routes: Routes = [
  {
    path: 'accueil',
    title: 'Story Lounge | Café & Lounge à Sfax',
    data: {
      description: 'Découvrez Story Lounge à Sfax : une ambiance unique, des boissons raffinées et des pâtisseries artisanales. Le lieu idéal pour vos pauses détente.',
      image: 'assets/screenshots/screenshot-desktop-home-1280x720.png'
    },
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomeComponent),
  },
  {
    path: 'menu',
    title: 'Menu | Story Lounge',
    data: {
      description: 'Explorez notre menu complet : cafés, thés, smoothies, jus frais et nos délices sucrés/salés. Commandez en ligne ou sur place.',
      image: 'assets/screenshots/screenshot-desktop-home-1280x720.png'
    },
    loadComponent: () => import('./pages/menu/menu.page').then(m => m.MenuComponent),
  },
  {
    path: 'menu/:familyName',
    title: 'Menu | Story Lounge',
    data: {
      description: 'Découvrez notre sélection de produits dans la catégorie choisie. Qualité et saveur garanties chez Story Lounge.',
      image: 'assets/screenshots/screenshot-desktop-home-1280x720.png'
    },
    loadComponent: () => import('./pages/menu/menu.page').then(m => m.MenuComponent),
  },
  {
    path: 'products/:familyName/:categoryName',
    title: 'Nos Produits | Story Lounge',
    data: {
      description: 'Détails de nos produits exclusifs. Faites votre choix parmi nos meilleures sélections.',
      image: 'assets/screenshots/screenshot-desktop-home-1280x720.png'
    },
    loadComponent: () => import('./pages/products/products.page').then(m => m.ProductsComponent),
  },
  {
    path: '**',
    redirectTo: 'accueil',
    pathMatch: 'full',
  },
];

